import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-cocoa/10 bg-cocoa px-5 py-10 text-background md:px-8" data-testid="site-footer">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="font-display text-4xl italic">Morgan Ella Books</p>
          <p className="mt-3 max-w-sm text-sm leading-6 text-background/60">Soft stories, tender endings, and shelves made for lingering.</p>
        </div>
        <div className="flex gap-6 text-xs uppercase tracking-[0.25em] text-background/60">
          <Link to="/about" data-testid="footer-about-link" className="transition-colors duration-300 hover:text-background">About</Link>
          <Link to="/books" data-testid="footer-books-link" className="transition-colors duration-300 hover:text-background">Books</Link>
          <Link to="/game" data-testid="footer-game-link" className="transition-colors duration-300 hover:text-background">Game</Link>
          <Link to="/playlist" data-testid="footer-playlist-link" className="transition-colors duration-300 hover:text-background">Playlist</Link>
          <Link to="/contact" data-testid="footer-contact-link" className="transition-colors duration-300 hover:text-background">Contact</Link>
        </div>
      </div>
    </footer>
  );
}
